import { render, staticRenderFns } from "./BaseCheckbox.vue?vue&type=template&id=f57bbfe2"
import script from "./BaseCheckbox.vue?vue&type=script&lang=js"
export * from "./BaseCheckbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/Companion.WebApp/ClientApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f57bbfe2')) {
      api.createRecord('f57bbfe2', component.options)
    } else {
      api.reload('f57bbfe2', component.options)
    }
    module.hot.accept("./BaseCheckbox.vue?vue&type=template&id=f57bbfe2", function () {
      api.rerender('f57bbfe2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ui/BaseCheckbox.vue"
export default component.exports